import React from 'react';
import { IconBase, IconBaseProps } from './IconBase';

export const ArrowRight: React.FunctionComponent<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 20 20">
    <rect x="11.2" y="14.3" width="5" height="2" transform="translate(-6.81 14.17) rotate(-45)" />
    <path d="M19.71,9.29,12.64,2.22,11.22,3.64,16.59,9H0v2H19a1,1,0,0,0,.92-.62A1,1,0,0,0,19.71,9.29Z" />
  </IconBase>
);
